import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { GET_PERMIT_TYPES_BY_ORGANIZATION_ID } from "../queries/getPermitTypesByOrganizationId";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";

const UPDATE_PERMIT_TYPE = gql`
  ${PERMIT_TEMPLATE_FIELDS}
  mutation UpdatePermitType($organizationId: String!, $permitTypeId: String!, $name: String!, $templateJson: String) {
    updatePermitType(input: { organizationId: $organizationId, permitTypeId: $permitTypeId, name: $name, templateJson: $templateJson }) {
      permitType {
        id
        name
        blueprintKey
        template {
          ...PermitTemplateFields
        }
      }
    }
  }
`;

export function useUpdatePermitType(organizationId: string) {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation(UPDATE_PERMIT_TYPE, {
    errorPolicy: "all",
    refetchQueries: [
      {
        query: GET_PERMIT_TYPES_BY_ORGANIZATION_ID,
        variables: { organizationId },
      },
    ],
  });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
